import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Home/Main'
import News from '@/components/News'
import NewsDetail from '@/components/NewsDetail'

import Product from '@/components/Product'
import Store from '@/components/Store'
import StoreView from '@/components/StoreView'
import Register from '@/components/Register'
import Active from '@/components/Member/Active'
import Forgotpass from '@/components/Forgotpass'
import About from '@/components/About'
import Privacy from '@/components/Privacy'
import Apply from '@/components/Apply'
import FreeTrial from '@/components/FreeTrial'
import Operators from '@/components/Operators'
import ProductView from '@/components/ProductView'
import StoreProductView from '@/components/StoreProductView'
import SearchProduct from '@/components/SearchProduct'
import GoodPrice from '@/components/GoodPrice'
import ShoppingCart from '@/components/ShoppingCart'
import Member from '@/components/Member/Member'
import Order from '@/components/Member/Order'
import Consume from '@/components/Member/Consume'
import Bonus from '@/components/Member/Bonus'
import Team from '@/components/Member/Team'
import Training from '@/components/Member/Training'
import Share from '@/components/Member/Share'
import Agreement from '@/components/Member/Agreement'
import Redeen from '@/components/Member/Redeen'
import Faq from '@/components/Faq'
import Contact from '@/components/Contact'
import Personal from '@/components/Member/Personal'
import Performance from '@/components/Member/Performance'
import ResetPassword from '@/components/ResetPassword'
import MemberPolicy from '@/components/MemberPolicy'
import Success from '@/components/Success'

Vue.use(Router)

const routes = [{
  path: '/',
  name: '首頁',
  component: Main
}, {
  path: '/Login',
  component: Main,
  name: '登入'
}, {
  path: '/register',
  component: Register,
  name: '註冊',
  description: '註冊'
}, {
  path: '/forgotpass',
  component: Forgotpass,
  name: '忘記密碼',
  description: '忘記密碼'
}, {
  path: '/ResetPassword/:token',
  component: ResetPassword,
  name: '重設密碼',
  description: '重設密碼'
}, {
  path: '/Success',
  component: Success,
  name: '訂購完成',
  description: '訂購完成'
}, {
  path: '/register/:id',
  component: Register
}, {
  path: '/about',
  component: About,
  name: '關於我們'
}, {
  path: '/privacy',
  component: Privacy,
  name: '隱私權政策'
}, {
  path: '/member_policy',
  component: MemberPolicy,
  name: '會員條款'
}, {
  path: '/operators',
  component: Operators,
  name: '聯盟經營者'
}, {
  path: '/apply',
  component: Apply,
  name: '加入聯盟'
}, {
  path: '/freetrial',
  component: FreeTrial,
  name: '免費加入平台'
}, {
  path: '/active/:id/:verifycode',
  component: Active,
  name: '用戶啟動'
}, {
  path: '/member',
  component: Member,
  meta: { requiresAuth: true },
  children: [
    {
      path: 'personal',
      component: Personal,
      name: '個人資料中心',
      meta: { requiresAuth: true }
    }, {
      path: 'consume',
      component: Consume,
      name: '消費紀錄',
      meta: { requiresAuth: true }
    }, {
      path: 'Order',
      component: Order,
      name: '訂單紀錄',
      meta: { requiresAuth: true }
    }, {
      path: 'performance',
      component: Performance,
      name: '績效查詢',
      meta: { requiresAuth: true }
    }, {
      path: 'bonus',
      component: Bonus,
      name: '回饋金查詢',
      meta: { requiresAuth: true }
    }, {
      path: 'team',
      component: Team,
      name: '組織查詢',
      meta: { requiresAuth: true }
    }, {
      path: 'redeen',
      component: Redeen,
      name: '抵用券',
      meta: { requiresAuth: true }
    }, {
      path: 'training',
      component: Training,
      name: '培訓專區',
      meta: { requiresAuth: true }
    }, {
      path: 'share',
      component: Share,
      name: '分享網址',
      meta: { requiresAuth: true }
    }, {
      path: 'agreement',
      component: Agreement,
      name: '合約中心',
      meta: { requiresAuth: true }
    }
  ]
}, {
  path: '/cart',
  component: ShoppingCart,
  name: '購物車'
}, {
  path: '/news',
  component: News,
  children: [
    {
      path: 'detail',
      component: NewsDetail,
      name: '最新消息'
    }
  ]
}, {
  path: '/news/:id',
  component: NewsDetail
}, {
  name: '產品',
  path: '/product',
  component: Product
}, {
  name: '產品詳細資訊',
  path: '/product/:id',
  component: ProductView
}, {
  name: '商家產品詳細資訊',
  path: '/store/product/:id/:fid',
  component: StoreProductView
}, {
  name: '商家產品/會員分享',
  path: '/store/product/:id/:fid/:shareid',
  component: StoreProductView
}, {
  name: '商品查詢',
  path: '/search/product',
  component: SearchProduct
}, {
  name: '愛幫您產品詳細，會員分享',
  path: '/product/:id/:shareid',
  component: ProductView
}, {
  name: '首購商品推廣畫面',
  path: '/goodprice/:id',
  component: GoodPrice
}, {
  name: '聯盟店家',
  path: '/store',
  component: Store
}, {
  name: '聯盟店家詳細',
  path: '/store/:id',
  component: StoreView
}, {
  name: 'FAQ',
  path: '/faq',
  component: Faq
}, {
  name: 'Contact',
  path: '/contact',
  component: Contact
}, {
  path: '*',
  component: Main
}]
export default routes



// WEBPACK FOOTER //
// ./src/router/index.js